import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {MsalAuthenticationTemplate, MsalProvider} from "@azure/msal-react";
import {InteractionType, PublicClientApplication} from "@azure/msal-browser";
import { RequireOutreachGroup } from "./RequireOutreachGroup"; 
import { RequirePortalDomain } from './RequirePortalDomain'; 

const hostname = String(window.location.hostname).toLowerCase();

let adc = process.env.REACT_APP_CLIENT_ID;
let adu = "https://login.microsoftonline.com/78bd1c27-3871-40f2-b397-b39c6d40bf3c";

// MSAL configuration
const config = {
	auth: {
		clientId: adc,
		authority: adu,
		tenantId:'78bd1c27-3871-40f2-b397-b39c6d40bf3c',
		postLogoutRedirectUri: window.location.origin,
		redirectUri: window.location.origin,
		validateAuthority: true,
		navigateToLoginRequestUrl: true
	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false,
	},
};

const authRequest = {
	scopes: ["openid", "profile"]
};

const pca = new PublicClientApplication(config);
const OUTREACH_GROUP_ID = "6cba1a4a-26cd-4e05-967a-5abf53171417";
// if(hostname.includes('community') || hostname.includes('spcadesexingtest.nz') || hostname.includes('localhost')) {

if (hostname.includes('community')  ) {
	ReactDOM.render(
		<MsalProvider instance={pca}>
			<MsalAuthenticationTemplate
				interactionType={InteractionType.Redirect}
				authenticationRequest={authRequest}
				errorComponent={ErrorComponent}
				loadingComponent={LoadingComponent}
			>
				 <RequirePortalDomain>
				<BrowserRouter>
					<App community />
				</BrowserRouter>
				</RequirePortalDomain>
			</MsalAuthenticationTemplate>
		</MsalProvider>,
		document.getElementById('root')
	);
} else if (hostname.includes('inspectors') ) {
	ReactDOM.render(
		<MsalProvider instance={pca}>
			<MsalAuthenticationTemplate
				interactionType={InteractionType.Redirect}
				authenticationRequest={authRequest}
				errorComponent={ErrorComponent}
				loadingComponent={LoadingComponent}
			>
				<RequirePortalDomain>
				<BrowserRouter>
					<App inspectors />
				</BrowserRouter>
				</RequirePortalDomain>
			</MsalAuthenticationTemplate>
		</MsalProvider>,
		document.getElementById('root')
	);
}
else if (hostname.includes('outreach')) {
	ReactDOM.render(
		<MsalProvider instance={pca}>
			<MsalAuthenticationTemplate
				interactionType={InteractionType.Redirect}
				authenticationRequest={authRequest}
				errorComponent={ErrorComponent}
				loadingComponent={LoadingComponent}
			>
				 <RequireOutreachGroup groupId={OUTREACH_GROUP_ID}>
				<BrowserRouter>
					<App outreach />
				</BrowserRouter>
				</RequireOutreachGroup>
			</MsalAuthenticationTemplate>
		</MsalProvider>,
		document.getElementById('root')
	);
} else {
	ReactDOM.render(
		<BrowserRouter>
			<App />
		</BrowserRouter>,
		document.getElementById('root')
	);
}

function ErrorComponent({error}) {
	return <p>An Error Occurred: {error}</p>;
}

function LoadingComponent() {
	return <p>Authentication in progress...</p>;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
